import Axios from "axios";
import MockAdapter from "axios-mock-adapter";
import {
  REQUEST_API,
  STORAGE_KEY,
  STORAGE_TYPE
} from "../../shared/utilties/Constants";
import { OfflineStorage } from "../../shared/utilties/OfflineStorage";
import { Configuration } from "../configuration/appsettings";
import { MockFunctions } from "./SetupMocks";

if (Configuration.useMock) {
  const mock = new MockAdapter(Axios, {
    delayResponse: Math.max(1000, Math.floor(Math.random() * 2000))
  });

  //Register all mocks.
  MockFunctions.map(mf => mf(mock));
}
export const API = Axios.create({
  baseURL: REQUEST_API.BASE_URL,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
    Authorization:"Bearer " +
    !!OfflineStorage.getItem(STORAGE_KEY.ACCESS_TOKEN, STORAGE_TYPE.LOCAL)
    ? OfflineStorage.getItem(STORAGE_KEY.ACCESS_TOKEN, STORAGE_TYPE.LOCAL)
    : "NO_TOKEN"
  }
});
API.interceptors.request.use(
  function(config) {
    //document.body.classList.add("showLoader");
    const token = !!OfflineStorage.getItem(
      STORAGE_KEY.ACCESS_TOKEN,
      STORAGE_TYPE.LOCAL
    )
      ? OfflineStorage.getItem(STORAGE_KEY.ACCESS_TOKEN, STORAGE_TYPE.LOCAL)
      : "NO_TOKEN";

    if (token != null) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function(err) {
    return Promise.reject(err);
  }
);
API.interceptors.response.use(
  function(response) {
    // spinning hide
    // UPDATE: Add this code to hide global loading indicator
    //document.body.classList.remove("showLoader");
    return response;
  },
  function(error) {
    //document.body.classList.remove("showLoader");
    return Promise.reject(error);
  }
);
